import { SVGProps, Ref, forwardRef } from 'react';

export const CheckboxLineSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path fillRule="evenodd" clipRule="evenodd" d="M18 12.9H6v-1.8h12z" fill="currentColor" />
    </svg>
));
CheckboxLineSize24Glyph.displayName = 'CheckboxLineSize24Glyph';
